export const docActionType = {
    SET_TOTAL_DOCS: 'SET_TOTAL_DOCS',
    SET_TODAY_DOCS: 'SET_TODAY_DOCS',
    SET_THISWEEK_DOCS: 'SET_THISWEEK_DOCS',
}